module.exports = __webpack_public_path__ + "img/beyharting_kreuzgang.d98b0ccd.jpg";